import { render, staticRenderFns } from "./commentary.vue?vue&type=template&id=941800e2&"
import script from "./commentary.vue?vue&type=script&lang=js&"
export * from "./commentary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports